import { render, staticRenderFns } from "./originalList.vue?vue&type=template&id=0ac73dba"
import script from "./originalList.vue?vue&type=script&lang=js"
export * from "./originalList.vue?vue&type=script&lang=js"
import style0 from "./originalList.vue?vue&type=style&index=0&id=0ac73dba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports